import React from 'react';
import { InputBaseComponentProps } from '@talentmesh/core';
import { NumericFormat } from 'react-number-format';

export interface NumberFormatterProps extends Omit<InputBaseComponentProps, 'defaultValue'> {}

export default function NumberFormatter(props: NumberFormatterProps) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            allowNegative={false}
        />
    );
}
